var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastInfo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.477,
    height: 15.094,
    viewBox: "0 0 17.477 15.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "warning_FILL0_wght400_GRAD0_opsz48_2_",
    "data-name": "warning_FILL0_wght400_GRAD0_opsz48 (2)",
    d: "M2,19.094,10.738,4l8.738,15.094ZM4.065,17.9H17.412L10.738,6.383Zm6.752-1.132a.577.577,0,1,0-.427-.169A.579.579,0,0,0,10.818,16.77Zm-.6-2.2h1.192V10.117H10.222ZM10.738,12.143Z",
    transform: "translate(-2 -4)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastInfo2);
export default __webpack_public_path__ + "static/media/toastInfo2.75f79892.svg";
export { ForwardRef as ReactComponent };